import { Box, Flex } from "rebass";
import useCart from "../../hooks/useCart";
import useResponsive from "../../hooks/useResponsive";
import Close from "../../icons/Close";
import TabButton from "./TabButton";
import CartClose from "../../icons/CartClose";
import CartNumber from "../../icons/CartNumber";
import { getLocalizedString } from "../../utils";
import { useState } from "react";
import MiniCart from "../cart/MiniCart";
import { useDispatch, useSelector } from "react-redux";
import { systemActions } from "../../logic/actions";

const MinicartButton = () => {
  const [showMinicart, setShowMinicart] = useState(false);

  const { activeNavButton } = useSelector((state) => state.system);

  const { showDebug } = useSelector((state) => state.yodaOrders);

  const dispatch = useDispatch();
  const { qtyReorder, qtySwap } = useCart();
  const { isMobile, isTabletSm } = useResponsive();

  const iconCount = qtyReorder + qtySwap;

  return (
    <>
      {isMobile || isTabletSm ? (
        <>
          <Flex
            width={"36px"}
            height={"50px"}
            sx={{
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              ...(activeNavButton === "cart" && {
                backgroundColor: ["#a2a2a2", "transparent"],
              }),
              display: ["block", , , "none"],
            }}
            onClick={() => {
              dispatch(
                systemActions.toggleMobileNavButton(
                  activeNavButton === "cart" ? null : "cart",
                ),
              );
            }}
          >
            {!(activeNavButton === "cart") && (
              <>
                {iconCount > 0 ? (
                  <Box sx={{ position: "relative" }}>
                    <CartNumber color="#fff" style={{ width: 24 }} />
                    <Box
                      sx={{
                        position: "absolute",
                        top: "-6px",
                        left: "11px",
                        fontWeight: 900,
                        color: "rgb(240, 136, 4)",
                        fontSize: "1.1em",
                        ...(iconCount > 9 && {
                          top: "-6px",
                          left: "8px",
                        }),
                        ...(iconCount > 99 && {
                          top: "-5px",
                          left: "8px",
                          fontSize: ".9em",
                        }),
                      }}
                    >
                      {iconCount > 99 ? "99+" : iconCount}
                    </Box>
                  </Box>
                ) : (
                  <CartClose
                    color="#fff"
                    style={{
                      width: 24,
                    }}
                  />
                )}
              </>
            )}
            {activeNavButton === "cart" && (
              <Close style={{ width: 20 }}></Close>
            )}
          </Flex>
          {activeNavButton === "cart" && (
            <Box
              style={{
                position: isMobile ? "fixed" : "absolute",
                top: isMobile ? "50px" : "40px",
                right: isMobile ? 0 : "-16px",
                left: isMobile ? 0 : null,
                width: isMobile ? "100vw" : "350px",
                backgroundColor: isMobile ? "#a2a2a2" : "#232323",
                color: "#FFFFFF",
                padding: isMobile ? null : "25px 20px",
                zIndex: 100,
              }}
            >
              <MiniCart />
            </Box>
          )}
        </>
      ) : (
        <>
          <Box
            onClick={() => {
              setShowMinicart(!showMinicart);
            }}
            sx={{
              position: "relative",
            }}
          >
            <TabButton
              isActive={showMinicart}
              activeIcon={
                iconCount > 0 ? (
                  <CartNumber style={{ width: 18 }} />
                ) : (
                  <CartClose style={{ width: 18 }} />
                )
              }
              tooltip={getLocalizedString("Visualizza carrello")}
              sx={{
                marginRight: "10px",
              }}
            />
            {iconCount > 0 && !showMinicart && (
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: "17px",
                  fontSize: ".8em",
                  fontWeight: 900,
                  color: "rgb(240, 136, 4)",
                  pointerEvents: "none",
                  ...(iconCount > 9 && {
                    top: "1px",
                    left: "15.5px",
                    fontSize: ".7em",
                  }),
                  ...(iconCount > 99 && {
                    top: "3px",
                    left: "15px",
                    fontSize: ".5em",
                  }),
                }}
              >
                {iconCount > 99 ? "99+" : iconCount}
              </Box>
            )}
          </Box>
          {showMinicart && (
            <Box
              style={{
                position: "absolute",
                top: "40px",
                right: 0,
                width: showDebug ? "400px" : "350px",
                backgroundColor: "#232323",
                color: "#FFFFFF",
                padding: "25px 10px 25px 20px",
                zIndex: 100,
              }}
            >
              <MiniCart />
            </Box>
          )}
        </>
      )}
    </>
  );
};

export default MinicartButton;
